import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// PayOrganizer Redux States
import {
  GET_PAYORGANIZERS,
} from "./actionType";

import {
  payOrganizerApiResponseSuccess,
  payOrganizerApiResponseError,
} from "./action";

//Include Both Helper File with needed methods
import {
  getPayOrganizers as getPayOrganizersApi,
} from "../../helpers/fakebackend_helper";

function* getPayOrganizers() {
  try {
    const response = yield call(getPayOrganizersApi);
    yield put(payOrganizerApiResponseSuccess(GET_PAYORGANIZERS, response));
  } catch (error) {
    yield put(payOrganizerApiResponseError(GET_PAYORGANIZERS, error));
  }
}

export function* watchGetPayOrganizers() {
  yield takeEvery(GET_PAYORGANIZERS, getPayOrganizers);
}



function* payOrganizerSaga() {
  yield all([
    fork(watchGetPayOrganizers),
  ]);
}

export default payOrganizerSaga;
